import {createSelector} from '@reduxjs/toolkit'
import {RootState} from './store'
import {State as DetailsState} from './detailsSlice'

const detailsSelector = (state: RootState): DetailsState => state.details

export const selectIssueDescription = createSelector(
  detailsSelector,
  (state) => state.details.issueDescription
)

export const selectAppName = createSelector(
  detailsSelector,
  (state) => state.details.appName
)

export const selectUrl = createSelector(
  detailsSelector,
  (state) => state.details.url
)

export const selectAppKey = createSelector(
  detailsSelector,
  (state) => state.details.appKey
)

export const selectProduct = createSelector(
  detailsSelector,
  (state) => state.details.product
)

export const selectUrgency = createSelector(
  detailsSelector,
  (state) => state.details.urgency
)

export const selectTicketNumber = createSelector(
  detailsSelector,
  (state) => state.ticketNumber
)

export const selectLoading = createSelector(
  detailsSelector,
  (state) => state.loading
)

export const selectErrorMessage = createSelector(
  detailsSelector,
  (state) => state.errorMessage
)
